import { render, staticRenderFns } from "./PopupQuizStart.vue?vue&type=template&id=6afe9d00&"
import script from "./PopupQuizStart.vue?vue&type=script&lang=js&"
export * from "./PopupQuizStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports